import React, { ReactNode } from 'react';
import { ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import _ from 'lodash';
import { SelectOptions } from '../commonType';
import styles from './toggleButtons.module.scss';
import classnames from 'classnames/bind';

type ToggleButtonsProps = {
  type?: any;
  value: string | number;
  name: string;
  options: SelectOptions[];
  onChange: (value: string | number) => void;
  className?: string;
  suffix?: ReactNode;
};

const cx = classnames.bind(styles);

const ToggleButtons: React.FunctionComponent<ToggleButtonsProps> = ({
  type,
  value,
  name,
  options,
  onChange: handleChange,
  className: parentClassName,
  suffix,
}) => {
  const className = cx(parentClassName, 'toggleButtons');
  return (
    <div className='flex items-center'>
      <ToggleButtonGroup
        type={type}
        value={value}
        onChange={handleChange}
        name={name}
        className={className}
      >
        {options &&
          options.map(({ label, value: childrenValue }: SelectOptions) => (
            <ToggleButton
              variant='secondary'
              key={childrenValue}
              value={childrenValue}
              id={`${name}-${childrenValue}`}
              active={value === childrenValue}
            >
              {label}
            </ToggleButton>
          ))}
      </ToggleButtonGroup>
      {suffix}
    </div>
  );
};

ToggleButtons.defaultProps = {
  type: 'radio',
  options: [],
  onChange: _.noop,
};

export default ToggleButtons;
